module.exports = __webpack_public_path__ + "static/up41-602e90cf43b6cde4984cd3a5eb30de48.png";